import { render, staticRenderFns } from "./AccreditationList.vue?vue&type=template&id=a7340094&scoped=true&"
import script from "./AccreditationList.vue?vue&type=script&lang=js&"
export * from "./AccreditationList.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationList.vue?vue&type=style&index=0&id=a7340094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7340094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VTextField,VTooltip})
